import { ClientNode } from '../../../../model/client-model/client-node';
import { ClientBoardContainer } from '../model/client-board-container';

export function isClientBoardContainer(item: ClientBoardContainer | ClientNode): item is ClientBoardContainer {
  return !!(item as ClientBoardContainer).nodes;
}
